import React from 'react'

import { useAppSelector } from '../../../store/hooks'
import { databasePageSelector } from '../../../store/slices/databasePage'
import DatabaseAddForm from '../DatabaseAddForm'
import DatabaseTable from '../DatabaseTable'
import { ContentMain, SelectedTableTitle } from './style'

const DatabaseContent = () => {
    const selectedTable = useAppSelector(databasePageSelector.selectedTable)

    return (
        <ContentMain>
            <SelectedTableTitle>
                Выбрана таблица: <span>{selectedTable}</span>
            </SelectedTableTitle>

            <DatabaseAddForm />
            <DatabaseTable />
        </ContentMain>
    )
}

export default DatabaseContent
